import { GTMolecularImportFn } from "../../components/GTMolecularImportFn";

const FN_NAME = "baylor-import-kits-received";

function FnRun() {
  return <GTMolecularImportFn name={FN_NAME} />;
}

export { FnRun };
